import { useTranslation } from 'react-i18next';
import usePageMeta from '@/hooks/usePageMeta';
import PageHero from '@/components/feature/PageHero';
import StorySection from '@/pages/about/components/StorySection';
import TimelineSection from '@/pages/about/components/TimelineSection';
import ManagementSection from '@/pages/about/components/ManagementSection';
import ValuesSection from '@/pages/about/components/ValuesSection';

export default function About() {
  const { t } = useTranslation();

  usePageMeta({
    title: 'Wir über uns | S+N Blech- und Metallverarbeitung',
    description:
      'Seit 2001 in Bernsbach gegründet: Erfahren Sie mehr über die Geschichte, den Generationswechsel und die Werte der S+N Blech- und Metallverarbeitungs GmbH.',
    keywords: 'S+N Metall Geschichte, Metallverarbeitung Bernsbach, Geschäftsführer Axel Friedrich',
  });

  return (
    <>
      <PageHero
        eyebrow={t('about.hero.eyebrow')}
        title={t('about.hero.title')}
        subtitle={t('about.hero.subtitle')}
      />
      <StorySection />
      <TimelineSection />
      <ManagementSection />
      <ValuesSection />
    </>
  );
}